export type CurrenciesType = 'USD' | 'HKD' | 'SGD' | 'NZD' | 'AUD' | 'EUR' | 'CAD' | 'GBP' | 'CNH';

// @ts-ignore
const currencyIcons = require.context('static/images/currency', false, /\.\/.*\.(svg|png|jpg)$/);
const currencyIconsMap = currencyIcons.keys().reduce(
    (map: Record<string, string>, key: string) => {
        const recommend = key.split(/\.|\//).slice(-2)[0];

        map[recommend] = currencyIcons(key);

        return map;
    },
    {} as Record<CurrenciesType, string>
);

// 非通用组件的情况下，不建议使用该类型，该类型不有应该与任何业务强耦合

/**
 * 获取币种对应的多语言
 * @param currency
 * @param isTrack 获取埋点相关数据
 */
export function getCurrencyInfo(currency: string) {
    const newCurrency = currency as CurrenciesType;

    switch (newCurrency) {
        case 'USD':
            return {
                name: __('美元'),
                icon: currencyIconsMap.USD
            };
        case 'HKD':
            return {
                name: __('港币'),
                icon: currencyIconsMap.HKD
            };
        case 'NZD':
            return {
                name: __('新西兰元'),
                icon: currencyIconsMap.NZD
            };
        case 'AUD':
            return {
                name: __('澳元'),
                icon: currencyIconsMap.AUD
            };
        case 'SGD':
            return {
                name: __('新加坡元'),
                icon: currencyIconsMap.SGD
            };
        case 'EUR':
            return {
                name: __('欧元'),
                icon: currencyIconsMap.EUR
            };
        case 'CAD':
            return {
                name: __('加拿大元'),
                icon: currencyIconsMap.CAD
            };
        case 'GBP':
            return {
                name: __('英镑'),
                icon: currencyIconsMap.GBP
            };
        case 'CNH':
            return {
                name: __('离岸人民币'),
                icon: currencyIconsMap.CNH
            };
        default:
            const _checkerNever: never = newCurrency;

            return {
                name: currency,
                icon: ''
            };
    }
}
